export const BRAND = {
  name: "Golf Motion Lab",
  tagline: "Laboratorio de valoración integral para golfistas",
  whatsapp: "+34614378460",
  whatsappDisplay: "+34 614 378 460",
  whatsappLink: "https://wa.me/34614378460",
  email: "info@golfmotionlab.es",
  domain: "golfmotionlab.es",
  instagram: "https://www.instagram.com/golfmotionlab/",
  linkedin: "https://www.linkedin.com/company/golf-motion-lab/",
  facebook: "https://www.facebook.com/profile.php?id=61590658561654",
  // Logos stored in webdev storage
  logoGreenHorizontal: "/img/logo_verde_horizontal_377c7af9.png",
  logoGreenStacked: "/img/logo_verde_completo_b3c39388.png",
  logoCreamHorizontal: "/img/logo_crema_horizontal_0a02a168.png",
  logoCreamStacked: "/img/logo_crema_completo_c88eeb5d.png",
  // Cream logo baked onto deep-green background, square (~1:1). Use it on dark surfaces.
  logoStackedOnGreen: "/img/gml-logo-stacked-cream-on-green_b6c0257c.png",
  // Vector version of the logo (cream graphics + Golf Motion Lab text) on solid brand-green background.
  logoStackedOnGreenSvg: "/img/gml-logo-stacked-on-green_27532961.svg",
  // Icon-only cream silhouette (transparent background) — use it on already-green surfaces.
  logoIconOnlyCream: "/img/gml-logo-icon-only-cream_631cb832.svg",
  // Full stacked logo (figure + "Golf / MOTION LAB" wordmark) in cream on transparent background.
  // Designed to sit on top of any brand-green surface without changing the typography.
  logoStackedCreamTransparent: "/img/gml-logo-stacked-cream-transparent_5ceff2cf.svg",
} as const; 
